import {takeEvery} from 'redux-saga/effects'
import {GET_INVENTORY_DASHBOARD_SUMMARY} from 'setup/redux/Actions/InventoryDashboard/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_INVENTORY_DASHBOARD_SUMMARY, fetchData)
}

export default dataSaga
